import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Text } from '../components/base/Text';
import { useTheme } from '../hooks';

export const PrivacyPolicyScreen = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  useTheme();

  const sections = ['section1', 'section2', 'section3', 'section4', 'section5'] as const;

  return (
    <div style={{ padding: 'var(--space-lg)' }}>
      <button
        type="button"
        onClick={() => navigate('/')}
        style={{ display: 'flex', alignItems: 'center', gap: 8, background: 'none', border: 'none', cursor: 'pointer', color: 'var(--color-accent)', marginBottom: 'var(--space-lg)' }}
      >
        <ArrowLeft size={20} /> {t('common.back', 'Back')}
      </button>
      <Text variant="display" as="h1" style={{ marginBottom: 'var(--space-xs)', color: 'var(--color-text-primary)' }}>
        {t('privacy.title')}
      </Text>
      <Text variant="meta" muted style={{ marginBottom: 'var(--space-lg)' }}>
        {t('privacy.lastUpdated')}
      </Text>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-lg)' }}>
        {sections.map((key) => (
          <div key={key}>
            <Text variant="title" style={{ color: 'var(--color-text-primary)', marginBottom: 'var(--space-sm)' }}>
              {t(`privacy.${key}.title`)}
            </Text>
            <Text variant="body" muted style={{ lineHeight: 1.6, whiteSpace: 'pre-line' }}>
              {t(`privacy.${key}.content`)}
            </Text>
          </div>
        ))}
      </div>
    </div>
  );
};
